import {useEffect, useState} from "react";
import info from "../assets/info-icon.png";
import Slider from "./Slider";
import tick from "../assets/dashboard-roi-tick.svg";

const ROITitleCard = (props) => {

    const generatingReport = props.generatingReport;
    const [teams, setTeams] = useState([])
    const [organisations, setOrganisations] = useState([])
    const [roiData, setRoiData] = useState(null)
    const [showPerformanceHover, setShowPerformanceHover] = useState(false)
    const [showBenchmark, setShowBenchmark] = useState(false)

    useEffect(() => {
        setTeams(props.teams)
    }, [props.teams]);

    useEffect(() => {
        setRoiData(props.data ?? null)
    }, [props.data]);

    useEffect(() => {
        if(!teams || !teams.length) {
            setOrganisations([]);
            return
        }
        // Deduplicate organisations by id + demo flag (not name) so
        // organisations sharing a name are counted separately
        let c = []
        for(const team of teams) {
            if(!c.some(x => x.id === team.organisation_id && x.demo === !!team.demo)) {
                c.push({
                    "id": team.organisation_id,
                    "demo": !!team.demo,
                    "name": team.organisation_name,
                    "colour": team.organisation_colour
                })
            }
        }
        setOrganisations(c)
    }, [teams])

    return (
        <div className="roi-report-title-card-container" style={{padding: generatingReport ? "10px 0" : null}}>
            <div className="roi-report-title-card-details-container">
                <div className="roi-report-title-card-heading">Overview</div>
                <div className="roi-report-title-card-subheading">Organisations:</div>
                <div className="roi-report-title-card-organisations-container">
                    {teams.length === 0 ? (
                        <div className="roi-report-title-card-no-teams">No teams selected</div>
                    ) : (
                        organisations.map((organisation, idx) => (
                            <div className="roi-report-title-card-organisation bold" key={idx}>
                                <div
                                    className="roi-report-title-card-organisation-colour"
                                    style={{ backgroundColor: organisation.colour }}
                                />
                                <div className="roi-report-title-card-organisation-name">{organisation.name}</div>
                            </div>
                        ))
                    )}
                </div>

                <div className="roi-report-title-card-subheading">
                    Total Teams: <span className="roi-report-title-card-detail-value">{teams.length}</span>
                </div>
                <div className="roi-report-title-card-subheading">
                    Total Participants: <span className="roi-report-title-card-detail-value">{roiData?.participant_count}</span>
                </div>
            </div>
            <div className="dashboard-roi-main-right full-report">
                <div className="dashboard-roi-right-title-container">
                    <div className="dashboard-roi-title bold">
                        Performance Over Time
                        <img src={info} alt="Info"
                             onMouseOver={() => setShowPerformanceHover(true)}
                             onMouseLeave={() => setShowPerformanceHover(false)}
                        />
                    </div>
                    {showPerformanceHover ?
                        <div className="dashboard-roi-title-hover" style={{top: 40, left: 210}}>
                            <div className="dashboard-roi-title-hover-triangle-outer">
                                <div className="dashboard-roi-title-hover-triangle-inner"/>
                            </div>
                            <div className="dashboard-roi-title-hover-text regular">
                                This table shows your combined aggregated PERILL scores (and function level) for
                                your teams* over time – including the overall percentage change. You can also
                                toggle on the benchmarking data to compare your teams performance metrics with
                                other teams across the platform.
                                <br/><br/>
                                *at least two initial and end point responses per team are required to qualify.
                            </div>
                        </div> : null
                    }
                    <div className="dashboard-roi-slider-container">
                        <Slider state={showBenchmark} update={setShowBenchmark.bind(this)}/>
                        <div className="dashboard-roi-slider-text medium">Add benchmarking data</div>
                    </div>
                </div>
                {teams.length > 0 ? (
                <div className="dashboard-roi-chart-container">
                    <div className="dashboard-roi-thermometer-heading regular">START OF COACHING ENGAGEMENT</div>
                    <div className="dashboard-roi-thermometer-container">
                        <div className="dashboard-roi-thermometer-score-circle bold"
                             style={{left: `${(roiData?.initial_score / 50) * 100}%`}}>
                            {roiData?.initial_score}
                        </div>
                        {showBenchmark ?
                            <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                 style={{ left: `${(roiData?.benchmark_initial / 50) * 100}%` }}>
                                {roiData?.benchmark_initial}
                            </div> : null
                        }
                        <div className="dashboard-roi-thermometer-outer-band">
                            <div className="dashboard-roi-thermometer-inner-band">
                                <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-roi-thermometer-markings-container bold">
                        <div className="dashboard-roi-thermometer-marking">0</div>
                        <div className="dashboard-roi-thermometer-marking">50</div>
                    </div>
                    <div className="dashboard-roi-vs bold">VS</div>
                    <div className="dashboard-roi-thermometer-heading regular top-margin">END OF COACHING ENGAGEMENT
                    </div>
                    <div className="dashboard-roi-thermometer-container">
                        <div className="dashboard-roi-thermometer-score-circle bold"
                             style={{ left: `${(roiData?.endpoint_score / 50) * 100}%` }}>
                            {roiData?.endpoint_score}
                        </div>
                        {showBenchmark ?
                            <div className="dashboard-roi-thermometer-score-circle benchmark bold"
                                 style={{ left: `${(roiData?.benchmark_end / 50) * 100}%` }}>
                                {roiData?.benchmark_end}
                            </div>
                            : null
                        }
                        <div className="dashboard-roi-thermometer-outer-band">
                            <div className="dashboard-roi-thermometer-inner-band">
                                <div className="dashboard-roi-thermometer-section bold low">LOW</div>
                                <div className="dashboard-roi-thermometer-section bold med">MEDIUM</div>
                                <div className="dashboard-roi-thermometer-section bold high">HIGH</div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-roi-thermometer-markings-container bold">
                        <div className="dashboard-roi-thermometer-marking">0</div>
                        <div className="dashboard-roi-thermometer-marking">50</div>
                    </div>
                    <div className="dashboard-roi-performance-change-container">
                        <div className="dashboard-roi-performance-container">
                            <div className="dashboard-roi-performance-title regular">PERFORMANCE % CHANGE</div>
                            <div className="dashboard-roi-performance-value-container bold">
                                {roiData && (roiData.improvement === -100 ?
                                        (<>N/A</>)
                                        : (
                                        <>
                                            {roiData.improvement}
                                            <span>%</span>
                                            <img src={tick} alt="Improvement" className="dashboard-roi-performance-tick"/>
                                        </>
                                    )
                                )}
                            </div>
                        </div>
                        {showBenchmark ? <div className="dashboard-roi-performance-divider"/> : null}
                        {showBenchmark ?
                            <div className="dashboard-roi-performance-container">
                                <div className="dashboard-roi-performance-title regular">BENCHMARK % CHANGE</div>
                                <div className="dashboard-roi-performance-value-container benchmark bold">
                                    {roiData?.benchmark_improvement}<span>%</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>

                ) : (
                    <div className="roi-report-title-card-no-teams">No teams selected</div>
                )}
            </div>
        </div>
    )
}


export default ROITitleCard